module.exports = __webpack_public_path__ + "img/overview_info3.0544ce88.jpg";